module.exports = __webpack_public_path__ + "img/banner_2015.3877efd3.png";